<template>
  <v-dialog v-model="viewDialogOther" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
            <span class="px-3">{{ $t('View Weight Auditor Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea2">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">{{ $t('Weight Auditor') }}</th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Date') }}</div>
                      <strong>{{ viewData.date }}</strong>
                    </td>
                    <td>
                      <div class="caption no-select">
                        {{ $t('Shift Time') }}
                      </div>
                      <strong>{{ $t(viewData.shift_time) }}</strong>
                    </td>
                    <td>
                      <div class="caption no-select">{{ $t('Factory') }}</div>
                      <strong>{{ viewData.factory_name || '-' }}</strong>
                    </td>
                    <td>
                      <div class="caption no-select">{{ $t('Type') }}</div>
                      <strong>{{ $t(viewData.type) }}</strong>
                    </td>
                  </tr>
                </table>

                <v-flex xs12 class="title no-select pb-1">
                  <hr style="margin: 15px 0px" />
                  <v-layout>{{ $t('Details') }}</v-layout>
                </v-flex>

                <table class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th xs1 class="pa-2 view-table-header">#</th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('Time') }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('Weight') }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('10 cover weight') }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('Carton weight') }}
                      </th>
                      <th class="view-table-header" xs3 pa-2>
                        {{ $t('Note') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewData.time[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewData.field_1[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewData.field_2[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewData.field_3[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content" v-html="lnToBr(viewData.note[index]) || '-'" />
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div class="footer-space">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </v-layout>
            </v-flex>
            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe2()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import invoiceHeader from '@/views/_partials/invoiceHeader.vue'
import invoiceFooter from '@/views/_partials/invoiceFooter.vue'

export default {
  name: 'view-component-other',

  props: {
    viewDialogOther: { type: Boolean, required: true }
  },

  components: {
    invoiceHeader,
    invoiceFooter
  },

  data() {
    return {
      rowNumbers: 0,
      viewData: {
        id: '',
        date: '',
        shift_time: '',
        factory_name: '',
        type: '',
        time: [],
        field_1: [],
        field_2: [],
        field_3: [],
        note: []
      }
    }
  },

  computed: {
    ...mapGetters({
      weightAuditorInfo: 'weightAuditors/getWeightAuditorInfo'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialogOther) {
        this.$emit('hidemodal')
      }
    })
  },

  watch: {
    viewDialogOther: {
      immediate: false,
      handler() {
        if (this.viewDialogOther) {
          this.viewData.time = []
          this.viewData.field_1 = []
          this.viewData.field_2 = []
          this.viewData.field_3 = []
          this.viewData.note = []
          this.viewData.id = this.weightAuditorInfo.weight_auditor_id
          this.viewData.date = this.weightAuditorInfo.date
          this.viewData.shift_time = this.weightAuditorInfo.shift_time
          this.viewData.factory_name = this.weightAuditorInfo.factory_name
          this.viewData.type = this.weightAuditorInfo.type
          this.rowNumbers = this.weightAuditorInfo.details.length
          this.weightAuditorInfo.details.forEach(data => {
            this.viewData.time.push(data.time)
            this.viewData.field_1.push(data.field_1)
            this.viewData.field_2.push(data.field_2)
            this.viewData.field_3.push(data.field_3)
            this.viewData.note.push(data.note)
          })
        }
      }
    }
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe2() {
      this.$emit('hideagricultural')
      setTimeout(() => {
        let onlyForPrint = document.querySelectorAll('.only-for-print')
        let notPrintable = document.querySelectorAll('.not-printable')
        let invoiceContent = document.querySelector('.invoice-content')
        let theDialogContent = document.querySelector('.view-dialog-content')
        let infoTable = document.querySelector('.info-table')
        theDialogContent.classList.remove('grey')
        infoTable.classList.add('add-padding-for-info-table')
        invoiceContent.style.marginTop = '90px'
        notPrintable.forEach(element => {
          element.style.display = 'none'
        })
        onlyForPrint.forEach(element => {
          element.style.display = 'block'
        })
        document.querySelector('.printed-table').style.marginTop = '-120px'

        this.$htmlToPaper('printArea2', () => {
          this.$emit('showagricultural')
          infoTable.classList.remove('add-padding-for-info-table')
          theDialogContent.classList.add('grey')
          invoiceContent.style.marginTop = '0px'
          onlyForPrint.forEach(element => {
            element.style.display = 'none'
          })
          notPrintable.forEach(element => {
            element.style.display = 'flex'
          })
          document.querySelector('.printed-table').style.marginTop = '0px'
        })
      }, 300)
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
